export default __webpack_public_path__ + "static/media/dollar2.ef03e0e4.png";